import React, { useState, useEffect } from "react";
import { db } from "../firebase.config";
import { collection, getDocs, query, orderBy, limit } from "firebase/firestore";
import SwiperCore, { EffectCoverflow, Pagination, Autoplay, EffectCards } from "swiper";
import "swiper/swiper-bundle.css";
import "swiper/swiper.min.css";
import "swiper/css/effect-cards";
import { useNavigate } from "react-router-dom";
import Spinner from "./Spinner";
import { Swiper, SwiperSlide } from "swiper/react";
SwiperCore.use([EffectCoverflow, Pagination, Autoplay, EffectCards]);



const Slider = () => {
  const [listings, setListing] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const userPic = 'https://openclipart.org/download/247319/abstract-user-flat-3.svg';

  useEffect(() => {
    const fetchListing = async () => {
      const listRef = collection(db, "listing");
      const q = query(listRef, orderBy("timestamp", "desc"), limit(5));
      const querySnap = await getDocs(q);
      let listings = [];
      querySnap.forEach((doc) => {
        return listings.push({
          id: doc.id,
          data: doc.data(),
        });
      });
      setListing(listings);
      setLoading(false);
    };
    fetchListing();
    console.log(listings === null ? "loading" : listings);
  }, []);
  if (loading) {
    return <Spinner />;
  }
  return (
    <>
      <div className="container d-flex align-items-center justify-content-center homsl" style={{width:'71%'}}>
        {listings === null  ? (
          <Spinner />
        ) : (
          <Swiper
            effect={"cards"}
            /*coverflowEffect={{
              rotate: 50,
              stretch: 0,
              depth: 100,
              modifier: 1,
              slideShadows: true,
            }}*/
            centeredSlides={true}
            autoplay={{
              delay:2000,
              disableOnInteraction:false
            }}
            pagination={true}
            className="myswipe img-thumbnail"
          >
            {listings.map(({data,id}) => (
              
              <SwiperSlide key={id} className="shadow-lg homeslide">
                <img
                  src={data.imgUrls[0]}
                  alt={data.name}
                  onClick={()=> {navigate(`/category/${data.type}/${id}`)}} style={{cursor:'pointer'}}
                />
                <h6 className="text-light p-2 m-0 ontop">
                    {/*<img alt="user pic" src={userPic} height={35} width={35} />*/}
                    <span className="ms-2">{data.name}</span><br/>
                    <span className="ms-2 add">{data.location}</span>
                </h6>
              </SwiperSlide>
            ))}
          </Swiper>
        )}
      </div>
    </>
  );
};

export default Slider;
